module.exports = __webpack_public_path__ + "img/app-header-alarm.192bebc0.svg";